/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Join_WaitlistInputs */

const en_booking_join_waitlist = /** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Waitlist`)
};

const es_booking_join_waitlist = /** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirse a la Lista de Espera`)
};

const fr_booking_join_waitlist = /** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre la liste d'attente`)
};

const de_booking_join_waitlist = /** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteliste beitreten`)
};

const id_booking_join_waitlist = /** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung Daftar Tunggu`)
};

/** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */
const ja_booking_join_waitlist = en_booking_join_waitlist;

/** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */
const zh_booking_join_waitlist = en_booking_join_waitlist;

/** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */
const ar_booking_join_waitlist = en_booking_join_waitlist;

/** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */
const it_booking_join_waitlist = en_booking_join_waitlist;

/** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */
const ru_booking_join_waitlist = en_booking_join_waitlist;

/** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */
const pt_booking_join_waitlist = en_booking_join_waitlist;

/** @type {(inputs: Booking_Join_WaitlistInputs) => LocalizedString} */
const ko_booking_join_waitlist = en_booking_join_waitlist;

/**
* | output |
* | --- |
* | "Join Waitlist" |
*
* @param {Booking_Join_WaitlistInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_join_waitlist = /** @type {((inputs?: Booking_Join_WaitlistInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Join_WaitlistInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_join_waitlist(inputs)
	if (locale === "es") return es_booking_join_waitlist(inputs)
	if (locale === "fr") return fr_booking_join_waitlist(inputs)
	if (locale === "de") return de_booking_join_waitlist(inputs)
	if (locale === "ja") return ja_booking_join_waitlist(inputs)
	if (locale === "zh") return zh_booking_join_waitlist(inputs)
	if (locale === "ar") return ar_booking_join_waitlist(inputs)
	if (locale === "id") return id_booking_join_waitlist(inputs)
	if (locale === "it") return it_booking_join_waitlist(inputs)
	if (locale === "ru") return ru_booking_join_waitlist(inputs)
	if (locale === "pt") return pt_booking_join_waitlist(inputs)
	return ko_booking_join_waitlist(inputs)
});